import { NumberDate } from '@lemon/core/model/common'
import { DateService } from '@lemon/core/service/date.service'
import { Asiakas, LemonaidPaymentConfig } from '../model/kayttaja'
import { FirestoreTosite } from '../model/tosite'

export class MaksutService {
  constructor(private _dateService: DateService) {}

  onkoMaksutiliVoimassa(paymentConfig: LemonaidPaymentConfig, currentNumberDate: NumberDate = this._dateService.currentNumberDate()): boolean {
    if (!paymentConfig || !paymentConfig.start) {
      return false
    }
    return this._dateService.onkoNumberKahdenValissa(currentNumberDate, paymentConfig.start, paymentConfig.end || 993112)
  }

  onkoMaksuHyvaksytty(tosite: FirestoreTosite, asiakas: Pick<Asiakas, 'paymentsNumberOfApprovalsRequired'>): boolean {
    return Object.values(tosite?.einvoiceApprovals ?? {}).length >= (asiakas.paymentsNumberOfApprovalsRequired ?? 1)
  }
}
